export default "__VITE_ASSET__01595e30__"